import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LeafletCircleMarkerComponent } from './leaflet-circle-marker.component';

@NgModule({
  declarations: [LeafletCircleMarkerComponent],
	exports: [LeafletCircleMarkerComponent],
  imports: [
    CommonModule
  ]
})
export class LeafletCircleMarkerModule { }
